import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { COMPANY_TYPES } from '../../../../../utils/common'
import { selectCompanyInfo } from '../../../../common/header/companyInfo/store/slice'
import { SCHEMA } from '../constants'

export const TitleRow = ({ getDataFromRedux, rowId }) => {
  const [isHovered, setIsHovered] = useState(false)

  const title = useSelector(getDataFromRedux(rowId, 'title'))
  const bankTitle = useSelector(getDataFromRedux(rowId, 'bankTitle'))
  const nonBankTitle = useSelector(getDataFromRedux(rowId, 'nonBankTitle'))
  const corpTitle = useSelector(getDataFromRedux(rowId, 'corpTitle'))
  const insTitle = useSelector(getDataFromRedux(rowId, 'insTitle'))
  const { companyType } = useSelector(selectCompanyInfo)

  const getTitle = () => {
    if (
      rowId === SCHEMA.industryNumActive.key &&
      companyType === COMPANY_TYPES.BANK
    ) {
      return bankTitle
    }

    if (
      rowId === SCHEMA.industryNumActive.key &&
      companyType === COMPANY_TYPES.NON_BANK
    ) {
      return nonBankTitle
    }

    if (
      rowId === SCHEMA.industryNetRevenue.key &&
      companyType === COMPANY_TYPES.CORPORATE
    ) {
      return corpTitle
    }

    if (
      [SCHEMA.industryNumActive.key, SCHEMA.industryNetRevenue.key].includes(
        rowId,
      ) &&
      [COMPANY_TYPES.LIFE_INSURANCE, COMPANY_TYPES.NON_LIFE_INSURANCE].includes(
        companyType,
      )
    ) {
      return insTitle
    }

    return title
  }

  const onMouseEnter = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <Element
      elementName="td"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      colSpan="5"
      className="fw600"
      style={{ backgroundColor: isHovered ? '#EDF5FE' : 'transparent' }}
    >
      <Translate value={getTitle()} />
    </Element>
  )
}
